import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as settings from '../../common/settings';
import { DisplaySettings } from '../display-settings';
import { constsMngr } from '../../common/consts';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { ColorPickerService } from '@core_n/common/color-picker/color-picker.service';
import { MatSliderChange } from '@angular/material/slider';
import { Animations } from '@core_n/Animations';

@Component({
  selector: 'points-settings',
  templateUrl: './sensors-settings.component.html',
  styleUrls: ['../display-filter.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class SensorsSettingsComponent extends ZIndexMngr implements AfterViewInit {
  @ViewChild('AcSelectedColorButton', { read: ElementRef }) private AcSelectedColorButton: ElementRef;
  @ViewChild('AcTextColorButton', { read: ElementRef }) private AcTextColorButton: ElementRef;

  private currentAcSelectedColor: string;
  private currentAcTextColor: string;

  static DIALOG_ID = "pointsSettings";

  pointElements: string[] = [];
  pointElementsOn = settings.userSettings.pointElementsOn;

  acousticElements: string[] = [];
  acousticElementsOn = settings.userSettings.acousticElementsOn;

  private defaultStyleColor: string;

  AcousticOpacity: number;
  AcousticLifeTime: number;

  constructor(public dialogRef: MatDialogRef<SensorsSettingsComponent>,
    private colorPickerSvc: ColorPickerService,
    elementRef: ElementRef) {
    super(elementRef);
    let style = getComputedStyle(document.body);

    for (let i = 0; i < constsMngr.pointDisplayElementCount(); i++)
      this.pointElements.push(constsMngr.pointDisplayElementTitle(i));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  onPointElemBtnClick(pointElem) {
    settings.userSettings.togglePointElementOn(pointElem);
  }
}
